/* istanbul ignore file */

import { KitbagShortlistsProvider as Provider } from '@statsbomb/kitbag-shortlists';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import env from '@/env';
import EN from '@/i18n/en';

export const KitbagShortlistsProvider = ({ children }: { children: ReactNode }) => {
  const { i18n } = useTranslation();

  // This is an intentional cast - it ensures that the keys in our i18n.json
  //   match those expected by the installed version of kitbag-shortlists.
  // If they don't match, this will throw a type error at compile time.
  const translations = i18n.getResourceBundle(i18n.language, 'shortlists') as typeof EN.shortlists;

  return (
    <Provider
      baseApiUrl={env.VITE_PARACHUTE_REST_API_ENDPOINT}
      baseGraphqlUrl={env.VITE_HUDL_URL}
      translations={translations}
    >
      {children}
    </Provider>
  );
};
